import styled from "styled-components";

const Container = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  padding: 100px 0 0 0;

  div {
    display: flex;
    flex-direction: column;

    padding: 30px 0 0 0;
    gap: 20px;
  }
`;

export default Container;
